<template>
  <div>
    <div class="form-group">
      <label class="idx-bold">
        {{ $t('newAction.stepOne.labels.methodology') }}
      </label>
      <select id="methodology-id" class="custom-select" :disabled="true">
        <option>
          {{ metric }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data: () => ({
    metric: null,
    editAction: null,
    options: [],
  }),

  computed: {
    ...mapState('companies', ['myMetric']),
    ...mapState('actions', ['action']),
    ...mapFields('actions', ['isEditAction']),
  },

  methods: {
    ...mapActions('actions', ['setMethodology']),
  },

  mounted() {
    // const editAction = JSON.parse(localStorage.getItem('is_edit_action'));

    // if (editAction) {
    //   this.isEditAction = true;

    //   localStorage.removeItem('is_edit_action');
    // }

    if (this.action.type === 'nps-0-10') {
      this.metric = this.$t('newAction.stepOne.scaleNps0a10');
    } else if (this.action.type === 'nps-1-5') {
      this.metric = this.$t('newAction.stepOne.scaleNps1a5');
    } else if (this.action.type === 'ces-1-5') {
      this.metric = this.$t('newAction.stepOne.labels.cesScale');
    } else if (this.action.type === 'csat-1-5') {
      this.metric = this.$t('newAction.stepOne.labels.csatScale');
    } else if (this.action.type === 'csat-1-5(media)') {
      this.metric = this.$t('newAction.stepOne.labels.csatScaleAverage');
    } else if (this.action.type === 'csat-0-10(media)') {
      this.metric = this.$t('newAction.stepOne.labels.csatScaleAverage0to10');
    }else if (this.action.type === '5-stars') {
      this.metric = this.$t('newAction.stepOne.labels.fiveStars');
    } else if (this.action.type === 'like-dislike') {
      this.metric = this.$t('newAction.stepOne.labels.likeDislike');
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/action-type/index.vue